import { apiClient } from "@lib/axios";
import type { TDesignSystem } from "@/shared/types";

const path = (path: string) => `/design-systems${path}`;

export const designSystemApi = {
  getThemes: () => {
    return apiClient.get<TDesignSystem[]>(path(""));
  },

  getThemeById: (id: string) => {
    return apiClient.get<TDesignSystem>(path(`/${id}`));
  },

  createTheme: (data: {
    payload: TDesignSystem["designSystem"];
    title: TDesignSystem["title"];
    customColors?: TDesignSystem["customColors"];
  }) => {
    return apiClient.post<TDesignSystem>(path(""), data);
  },

  updateTheme: (data: {
    id: string;
    payload: TDesignSystem["designSystem"];
    title: TDesignSystem["title"];
    customColors?: TDesignSystem["customColors"];
  }) => {
    return apiClient.put<TDesignSystem>(path(`/${data.id}`), {
      payload: data.payload,
      title: data.title,
      customColors: data.customColors,
    });
  },

  deleteTheme: (id: string) => {
    return apiClient.delete<void>(path(`/${id}`));
  },
};
